import { SECOND_STP_STATUS_OPTIONS } from "../../../../constants/submissionSummaryOptions";

export const allSecondStpStatusOptions = SECOND_STP_STATUS_OPTIONS.map(
  (option) => ({
    label: option.text,
    value: option.id,
  }),
);
